"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCallTransferTypeEnum = void 0;
var VoiceCallTransferTypeEnum;
(function (VoiceCallTransferTypeEnum) {
    VoiceCallTransferTypeEnum["Attended"] = "a";
    VoiceCallTransferTypeEnum["Blind"] = "b";
})(VoiceCallTransferTypeEnum = exports.VoiceCallTransferTypeEnum || (exports.VoiceCallTransferTypeEnum = {}));
